import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { fetchCategories } from "../redux/actions/categoryActions";
import ErrorAlert from "../components/common/ErrorAlert";
import LoadingBlock from "../components/common/LoadingBlock";
import CategoryGemsModal from "../components/gems/CategoryGemsModal";

function getCategoryUid(c) {
  return c?.uid || c?.cms_uid || c?.cmsUid || c?.category_uid || c?.slug || c?.key;
}

function getCategoryTitle(c) {
  return c?.title || c?.name || c?.label || getCategoryUid(c) || "Category";
}

function getCategoryDescription(c) {
  return c?.description || c?.desc || c?.subtitle || "";
}

function getCategoryGemsCount(c) {
  const n = c?.gems_count ?? c?.gemsCount;
  return typeof n === "number" ? n : null;
}

function getCategoryImageUrl(c) {
  return c?.image_url || c?.imageUrl || c?.cover_url || "";
}

export default function CategoriesPage() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.categories);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  if (loading) return <LoadingBlock label="Loading categories..." />;

  return (
    <div>
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">Explore</div>
              <h2 className="page-title">Gem Categories</h2>
            </div>
          </div>
        </div>
      </div>

      <ErrorAlert error={error} title="Failed to load categories" />

      <Row className="row-deck row-cards">
        {(items || []).map((c) => {
          const uid = getCategoryUid(c);
          const imageUrl = getCategoryImageUrl(c);
          const gemsCount = getCategoryGemsCount(c);
          const desc = getCategoryDescription(c);
          return (
            <Col key={uid || JSON.stringify(c)} xs={12} md={6} lg={3}>
              <Card className="card-sm">
                {imageUrl ? (
                  <Card.Img
                    variant="top"
                    src={imageUrl}
                    alt=""
                    style={{ height: 140, objectFit: "cover" }}
                  />
                ) : null}
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="flex-fill">
                      <div className="fw-bold">{getCategoryTitle(c)}</div>
                      {desc ? <div className="text-muted small">{desc}</div> : null}
                      {gemsCount !== null ? (
                        <div className="text-muted small">
                          {gemsCount} gem{gemsCount === 1 ? "" : "s"}
                        </div>
                      ) : !desc ? (
                        <div className="text-muted small">—</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="mt-3">
                    <button
                      className="btn btn-primary w-100"
                      type="button"
                      onClick={() => setSelectedCategory(c)}
                    >
                      View
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>

      <CategoryGemsModal
        show={!!selectedCategory}
        onHide={() => setSelectedCategory(null)}
        category={selectedCategory}
      />
    </div>
  );
}

